/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m21.75 11.411-2.584-2.583c-.499-.5-1.416-.167-1.416.583v1.584a.18.18 0 0 1-.166.166H2.834c-.5 0-.834.334-.834.834 0 .5.333.833.833.833h14.75a.18.18 0 0 1 .168.167v1.583c0 .75.916 1.084 1.415.583l2.585-2.583a.807.807 0 0 0 0-1.167Z"
})), "0 0 24 24", "RouteNoStops");